// Sugalarm — /api/account wrappers.

import { request } from "../lib/apiClient";
import type { ApiResult } from "../lib/types";
import type { DeletionPreview } from "../lib/accountDeletion";

/** Permanently delete the signed-in user's OWN account + all their data.
 *  Self-only on the server (no target param exists), JWT-only. */
export function deleteMyAccount(): Promise<
  ApiResult<{ ok: boolean; deleted: string }>
> {
  return request<{ ok: boolean; deleted: string }>("/api/account", {
    method: "DELETE",
  });
}

/** Cycle 463.1: what deleting the account does to its billing, for the
 *  confirmation step. JWT-only, self-scoped like the delete itself. */
export function getDeletionPreview(): Promise<ApiResult<DeletionPreview>> {
  return request<DeletionPreview>("/api/account/deletion-preview");
}
